export default () => {
  	var footerEls = document.getElementsByClassName("footer");
  	var footerEl = footerEls[0];
  	footerEl.classList.add("hereWeGo");
  	var popUps = [
  //	    '<div class="quiz-popup qpop"><div class="container"><a class="quiz-popup__overlay" href="https://vk.com/video-197986916_456239998" target="_blank"><img class="quiz-popup__close" /><img class="quiz-popup__bg" src="https://files-stage.digitalrussia.tv/download/images/182f8096-fc80-4000-8fc5-010e7f383e80.jpg" /></a></div></div>', 
  // '<div class="quiz-popup qpop"><div class="container"><a class="quiz-popup__overlay" href="https://kino.mosfilmgold.ru/" target="_blank"><img class="quiz-popup__close" /><img class="quiz-popup__bg" src="https://files-stage.digitalrussia.tv/download/images/18466749-8620-4000-84f2-b8504f778b00.jpg" /></a></div></div>'
  	];
    if(popUps.length){
    	var popUpHTML = popUps[Math.floor(Math.random() * popUps.length)];
    	footerEl.insertAdjacentHTML("beforeend", popUpHTML);
    }
  	let popup =
  	    document.location.pathname === "/igra"
  	        ? false
  	        : document.querySelector(".quiz-popup");
  	let poster =
  	    document.location.pathname === "/poster"
  	        ? document.querySelector(".quiz-inner-popup")
  	        : false;
  	if (popup) {
  	    popup.style.opacity = "1";
  	    popup.style.zIndex = "5000";
  	}
  	if (poster) {
  	    localStorage.setItem("quiz", true);
  	    poster.style.opacity = "1";
  	    poster.style.zIndex = "5000";
  	}
  
  	popup &&
  	    popup.addEventListener("click", (e) => {
  	        if (
  	            e.target.classList.contains("container") ||
  	            e.target.classList.contains("quiz-popup") ||
  	            e.target.classList.contains("quiz-popup__close") ||
  	            e.target.classList.contains("quiz-inner-popup__link")
  	        ) {
  	            e.preventDefault();
  	            popup.style.opacity = "0";
  	            setTimeout(() => {
  	                //   popup.style.zIndex = "-5000";
  	                popup.style.cssText = "visibility:hidden;z-index:-5000;width:0;height:0"
  	            }, 300);
  	        }
  	    });
  	popup &&
  	    popup.addEventListener("click", (e) => {
  	        if (e.target.classList.contains("quiz-popup__bg")) {
  	            popup.style.opacity = "0";
  	            setTimeout(() => {
  	                //  popup.style.zIndex = "-5000";
  	                popup.style.cssText = "visibility:hidden;z-index:-5000;width:0;height:0"
  	            }, 300);
  	        }
  	    });
  	poster &&
  	    poster.addEventListener("click", (e) => {
  	        if (
  	            e.target.classList.contains("container") ||
  	            e.target.classList.contains("quiz-popup") ||
  	            e.target.classList.contains("quiz-popup__close") ||
  	            e.target.classList.contains("quiz-inner-popup__link")
  	        ) {
  	            poster.style.opacity = "0";
  	            setTimeout(() => {
  	                //   poster.style.zIndex = "-5000";
  	                poster.style.cssText = "visibility:hidden;z-index:-5000;width:0;height:0"
  	            }, 300);
  	        }
  	    });
  }
